import { UsersTypes } from '@frontend/user-helpers';
import { customContextFactory } from '../../../../../../hooks/custom-context-factory';

type ContextType = {
  locationUsers?: UsersTypes.User[];
  refetchScheduleRequestList: () => void;
};

export const [ScheduleRequestContextProvider, useScheduleRequestContext] = customContextFactory<ContextType>();
